import logoSrc from "../../../maherLogo.png";

interface CardLogoProps {
  size?: number;
}

/** Platform logo rendered on a white pill — used in every card header. */
export default function CardLogo({ size = 48 }: CardLogoProps) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: "6px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: size,
      }}
    >
      <img
        src={logoSrc}
        alt="clifton logo"
        style={{ height: size - 12, objectFit: "contain", display: "block" }}
      />
    </div>
  );
}
